import * as React from 'react';
import styled from 'styled-components';
import { useTheme, withThemeProvider } from '@narvar/nth-hook-theme';

// TODO: make this its own font token and separate
// it from the rest of the panel header styling
const StyledPanelHeaderText = styled.div<{
  panelHeaderStyle: React.CSSProperties;
  bodyTextStyle: React.CSSProperties;
}>(({ panelHeaderStyle, bodyTextStyle }) => ({
  marginBottom: '0.5rem',
  fontSize: panelHeaderStyle?.fontSize,
  textTransform: panelHeaderStyle?.textTransform,
  fontFamily: panelHeaderStyle?.fontFamily,
  fontWeight: panelHeaderStyle?.fontWeight,
  color: bodyTextStyle?.color,
}));

const PanelHeaderText: React.FunctionComponent = ({ children }) => {
  const {
    panelheaderNoneNone: panelHeaderStyle,
    bodytextDefaultNone: bodyTextStyle,
  } = useTheme();

  return (
    <StyledPanelHeaderText
      panelHeaderStyle={panelHeaderStyle}
      bodyTextStyle={bodyTextStyle}
    >
      {children}
    </StyledPanelHeaderText>
  );
};

export default withThemeProvider(PanelHeaderText, {
  themeTokens: ['panelheaderNoneNone', 'bodytextDefaultNone'],
});
